import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import PaymentModal from './PaymentModal';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { envAwarePost } from "../../util/util";
import {stripePromiseLatest as stripePromise} from '../../payments/stripe'
import useCurrencySettings from '../../hooks/useCurrencySettings'
import { updatePresentmentCurrency } from './settingsSlice'
import { Link } from "react-router-dom";
import CancelAccount from "../CancelAccount/CancelAccount"
import {getCurrencySymbol} from '../../util/intl'
import classes from "./Settings.module.css"
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";
import { updateTimeSettings } from "../users/usersSlice";
import Turnstile from "react-turnstile"

function GeneralSettings({ generalSettings, setGeneralSettings, setTriggerReload }) {
    const dispatch = useDispatch()
    
    const { acceptedCurrency, acceptedCurrencies } = useCurrencySettings()
    const gymId = useSelector(state => state.users.current_user.gym_id);
    const accountType = useSelector(state => state.users.current_user.account_type);
    const isPartOfGym = gymId != 0
    const isTrainer = accountType === "trainer";
    const isGym = accountType === 'gym'
    const isOwner = isPartOfGym ? isGym : isTrainer
    const [showCancelAccount, setShowCancelAccount] = useState(false);

    const handleUpdateCurrency = e => {
        const currency_id = e.target.value
        dispatch(updatePresentmentCurrency(currency_id))
    }

    function updateDatabase(system) {
        envAwarePost( 'api/user/api', {
            action: 'updateMeasurementSystem',
            system: system
        }).then( res => {
            console.log(res)
        }).catch( err => console.log(err) )
    }

    function dispatchUpdateTimeSettings(is_24_hour_time){
        dispatch(updateTimeSettings({
            is_24_hour_time
        }))
    }

    const setupIntent = () => envAwarePost('api/user/api/',{action:'setupIntent',updating_payment_info:1,captcha_token:token})
    const [clientSecret,setClientSecret] = useState(null)
    const [token, setToken] = useState(null)
    useEffect(async()=>{
        if(isOwner&&Boolean(token)){
            const res = await setupIntent()
            console.log('setup intent: ',res)
            setClientSecret(res.data)
        }
    },[token])

    

    //billing info state
    const [cardInfoStatus, setCardInfoStatus] = useState('loading')
    const [cardInfo, setCardInfo] = useState(null)
    const [showPaymentModal, setShowPaymentModal] = useState(false)

    const togglePaymentModal = () => { setShowPaymentModal(!showPaymentModal) }

    //if on localhost
    const isLocal = window.location.host.indexOf('localhost') > -1
    //if in react dev server
    const isDev = window.location.host.indexOf('localhost:') > -1

    const fetchPaymentInfo = () => {
        setCardInfoStatus('loading')
        envAwarePost(
            'api/settings/api/',
            { action: 'getPaymentInfo' }
        ).then(res => {
            const { success, data, message } = res
            console.log(data)
            if (success === '1') {
                setCardInfo(data)
            } else {
                window.alert(message)
            }//end if(success){}else{}
            setCardInfoStatus('loaded')
        })//end envAwarePost.then
    }

    useEffect(fetchPaymentInfo, [])//end useEffect

    console.log(stripePromise,clientSecret)

    return (
        <>
            <Card className={`${classes.cardWidth} mb-5 shadow`}>
                <Card.Body>
                    <h4>General</h4><hr class="mt-1" />
                    <Row className="mb-3">
                        <Col sm={4}>
                            Account Details:
                        </Col>
                        <Col sm={8} className="mb-2" style={{ textTransform: "capitalize" }}>
                            {(isTrainer && gymId != 0) ?
                                <span>
                                    Gym Trainer plan with ID Code <u><strong>{generalSettings.userID}</strong></u>
                                </span> :
                                <span>
                                    {generalSettings.accountType} {generalSettings.maxClients} plan with ID Code <u><strong>{generalSettings.userID}</strong></u>
                                </span>}

                        </Col>
                    </Row>
                    {(isTrainer && gymId !== "0") ? null :
                        <>
                            <Row className="mb-1">
                                <Col md={4} className="align-self-center">
                                    Payment Info:
                                </Col>
                                <Col md={8} lg={4} style={{ textTransform: "capitalize" }}>
                                    {
                                        cardInfoStatus === 'loading' ?
                                            <Spinner animation="border" size="sm" /> :
                                            (cardInfo?.payment_method_exists &&
                                                <div>
                                                    <span className="mr-1">
                                                        {cardInfo.brand} ending in {cardInfo.last4}
                                                    </span>
                                                    <br/>
                                                    <Button
                                                        onClick={togglePaymentModal}
                                                        variant="outline-primary"
                                                        size="sm"
                                                    >
                                                        Update Payment Info
                                                    </Button>
                                                </div>
                                            )
                                    }
                                </Col>
                                <Col
                                    lg={cardInfoStatus === "loaded" ? (cardInfo?.payment_method_exists ? 4 : 12) : null}
                                    className="align-self-center mt-2"
                                >
                                    <a role="button" className="text-primary" onClick={() => setShowCancelAccount(true)}> <u> Need to Cancel? </u> </a>
                                </Col>
                            </Row>
                            <div className="mb-3">
                                <small>Verifying that you are human</small>
                                <Turnstile
                                    sitekey="0x4AAAAAAA9Mp8wfRxeg2JCV"
                                    onVerify={(captchaToken) => setToken(captchaToken)}
                                />
                            </div>
                        </>
                    }
                    {isOwner &&
                        <Row className="mb-3">
                            <Col sm={4}>
                                <OverlayTrigger overlay={
                                    <Tooltip>
                                        This currency setting is for how prices are displayed on items you offer to your clients.
                                    </Tooltip>
                                }>
                                    <i className="fas fa-info-circle mr-1" />
                                </OverlayTrigger>
                                Default Currency:
                                <small className="d-block text-info">
                                    Don't see your currency? <br/> contact 
                                    <a 
                                        className="ml-1"
                                        href="mailto:support@fitsw.com?subject=Please Add My Currency"
                                    >
                                        support@fitsw.com
                                    </a>
                                    
                                </small>
                            </Col>
                            <Col sm={8} className="mb-2">
                                <Form.Control
                                    onChange={handleUpdateCurrency}
                                    value={acceptedCurrency.id}
                                    as="select"
                                >
                                    {acceptedCurrencies.map(ac => (
                                        <option key={ac.id} value={ac.id}>
                                            {
                                                getCurrencySymbol(ac.ISO) === ac.ISO ?
                                                ac.ISO :
                                                `${getCurrencySymbol(ac.ISO)} ${ac.ISO}`
                                            }
                                        </option>
                                    ))}
                                </Form.Control>
                                <small className="text-danger d-block">
                                    <i class="fas fa-exclamation-circle"></i> only newly created items/merchandise will have this as the currency
                                </small>
                            </Col>
                        </Row>
                    }
                    <Form.Group as={Row} className="mb-2" controlId="unitsOfMeasure">
                        <Col sm={4}>
                            <Form.Label className="col-form-label">
                                Units of Measure
                            </Form.Label>
                        </Col>
                        <Col sm={4}>
                            <Form.Control
                                value={generalSettings.measurementSystem}
                                className="form-control-alternative"
                                name="measurementSystem" as="select"
                                onChange={(e) => {
                                    let name = e.target.name;
                                    let value = e.target.value;
                                    setGeneralSettings(prev => ({ ...prev, [name]: value }));
                                    updateDatabase(value);
                                }}
                            >
                                <option value="metric"> Metric System  </option>
                                <option value="imperial"> Imperial </option>

                            </Form.Control>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-2" controlId="isTime24Hour">
                        <Col sm={4}>
                            <Form.Label className="col-form-label">
                                Time Settings
                            </Form.Label>
                        </Col>
                        <Col sm={4}>
                            <Form.Control
                                value={generalSettings.isTime24Hour}
                                className="form-control-alternative"
                                name="isTime24Hour" as="select"
                                onChange={(e) => {
                                    let name = e.target.name;
                                    let value = e.target.value;
                                    setGeneralSettings(prev => ({ ...prev, [name]: value }));
                                    dispatchUpdateTimeSettings(value);
                                }}
                            >
                                <option value="0"> 12 Hour Clock </option>
                                <option value="1"> 24 Hour Clock </option>

                            </Form.Control>
                        </Col>
                    </Form.Group>
                    

                    {(Number(generalSettings.maxClients) <= 1) && <>
                        <a role="button" className="text-primary" onClick={() => setShowCancelAccount(true)}> <u> Need to Cancel? </u> </a>
                    </>}

                </Card.Body>
            </Card>
            {(Boolean(stripePromise)&&Boolean(clientSecret))&&
                <Elements stripe={stripePromise} options={{clientSecret}}>
                    <ElementsConsumer>
                        {({ elements, stripe }) => (
                            <PaymentModal
                                toggle={togglePaymentModal}
                                show={showPaymentModal}
                                elements={elements}
                                stripe={stripe}
                                refresh={fetchPaymentInfo}
                            />
                        )}
                    </ElementsConsumer>
                </Elements>
            }

            <CancelAccount showCancelAccount={showCancelAccount} setShowCancelAccount={setShowCancelAccount} setTriggerReload={setTriggerReload} />
        </>
    )
}

export default GeneralSettings